// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tKz9","colBig":"styles_colBig__1gHuO","colSmall":"styles_colSmall__YXNp4","shopifyNameWrapper":"styles_shopifyNameWrapper__1xK61"};